import classNames from "classnames";
import dayjs from "dayjs";
import { useMemo } from "react";
import { AdminCalendarIcon } from "../../AscIcons";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscTable from "../AscTable";
import styles from "./AscMessagesTable.module.scss";

enum DataMessagesTableEnum {
  userName = "userName",
  position = "position",
  message = "message",
  status = "status",
  time = "time",
}

type DataMessagesTable = {
  userName: string;
  position: string;
  message: any;
  status: string | any;
  time: string;
};

interface IMessagesTableProps {
  data: DataMessagesTable[];
  onClick?: () => void;
}

export default function AscMessagesTable(props: IMessagesTableProps) {
  const { data } = props;
  const tableData: DataMessagesTable[] = useMemo(() => [...data], [data]);

  const tableColumns = useMemo(() => {
    const columns = [
      {
        Header: () => {
          return (
            <AscParagraph className={styles.headName}>From / To </AscParagraph>
          );
        },
        accessor: DataMessagesTableEnum.userName,
      },

      {
        Header: () => {
          return (
            <AscParagraph className={styles.headName}>Status </AscParagraph>
          );
        },
        accessor: DataMessagesTableEnum.position,
        Cell: (cell: { value: any }) => {
          return (
            <div>
              <span
                className={classNames(styles.position, {
                  [styles.student]: cell.value === "Student",
                  [styles.parent]: cell.value === "Parent",
                })}
              >
                {cell.value}
              </span>
            </div>
          );
        },
      },

      {
        Header: () => {
          return (
            <AscParagraph className={styles.headName}>Message</AscParagraph>
          );
        },
        accessor: DataMessagesTableEnum.message,
        Cell: (cell: { value: string }) => {
          return (
            <div className={styles.messagePreview}>
              {cell.value && cell.value.length > 50
                ? cell.value.substring(0, 50) + "..."
                : cell.value}
            </div>
          );
        },
      },

      {
        Header: () => {
          return (
            <AscParagraph className={styles.headName}>Status </AscParagraph>
          );
        },
        accessor: DataMessagesTableEnum.status,
        Cell: (cell: { value: any }) => {
          return (
            <div className={styles.statusGround}>
              <div
                className={classNames(styles.circle, {
                  [styles.green]: cell.value === "Sent",
                  [styles.yellow]: cell.value === "Inbox",
                })}
              />
              {cell.value}
            </div>
          );
        },
      },

      {
        Header: () => {
          return <AscParagraph className={styles.headName}>Time </AscParagraph>;
        },
        accessor: DataMessagesTableEnum.time,
        Cell: (cell: { value: any }) => {
          return (
            <div className={styles.dateGround}>
              <AdminCalendarIcon className={styles.iconCalendar} />
              {dayjs(cell.value).format("DD MMM YYYY, HH:mm")}
            </div>
          );
        },
      },
    ];

    return columns;
  }, [tableData]);
  return (
    <AscTable
      tHead={styles.tHead}
      tBody={styles.tBody}
      tH={styles.tH}
      tD={styles.tD}
      tHeadRow={styles.tHeadRow}
      tBodyValue={styles.tBodyValue}
      pureCellFlow={styles.pureCellFlow}
      className={styles.table}
      paginationStyle={styles.paginationStyle}
      tableColumns={tableColumns}
      tableData={tableData}
      showHeader={true}
      onClickTD={props.onClick}
    />
  );
}
